import React, { useEffect, useState } from "react";
import "./ProgressBar.scss";
import Text from "../Text/Text";

const ProgressBar = ({ value = 0, color, label, icon, statusText }) => {
    const clamped = Math.min(100, Math.max(0, value));

    const [visibleText, setVisibleText] = useState(statusText);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        setFade(false);
        const timer = setTimeout(() => {
            setVisibleText(statusText);
            setFade(true);
        }, 150);
        return () => clearTimeout(timer);
    }, [statusText]);

    return (
        <div className="progress-bar-field">
            {(label || icon) && (
                <div className="progress-bar-field__header">
                    {icon && <span data-icon={icon} className="icon progress-bar-field__icon" />}
                    {label && (
                        <Text size="small" color="var(--gray-dark-500)" className="progress-bar-field__label">
                            {label}
                        </Text>
                    )}
                    <Text size="small" color="var(--gray-dark-500)" className="progress-bar-field__value">
                        {clamped}%
                    </Text>
                </div>
            )}
            {!label && !icon && (
                <div className="progress-bar-field__header progress-bar-field__header--value-only">
                    <Text size="small" color="var(--gray-dark-500)" className="progress-bar-field__value">
                        {clamped}%
                    </Text>
                </div>
            )}
            <div className="progress-bar">
                <div
                    className="progress-bar__fill"
                    style={{
                        width: `${clamped}%`,
                        backgroundColor: color || "var(--blue-600)",
                    }}
                />
            </div>
            {visibleText && (
                <Text
                    size="small"
                    color="var(--gray-dark-500)"
                    className={`progress-bar-field__status ${fade ? "progress-bar-field__status--visible" : ""}`}
                >
                    {visibleText}
                </Text>
            )}
        </div>
    );
};

export default ProgressBar;
